import { fakeHash } from './fakeHash';
import { hashFromUuid } from './hashFromUuid';
export const getOrderCreationHash = (uuid) => [fakeHash(), hashFromUuid(uuid), fakeHash()].join('');
